import { render } from "./CollectionProductCategoryFormView.vue?vue&type=template&id=f6f172d2"
import script from "./CollectionProductCategoryFormView.vue?vue&type=script&lang=js"
export * from "./CollectionProductCategoryFormView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__